<template>
  <div class="project-view">
    <el-card shadow="never">
      <template #header>
        <div class="card-header">
          <span>项目详情</span>
          <el-button @click="goBack">
            <el-icon><ArrowLeft /></el-icon>
            返回
          </el-button>
        </div>
      </template>
      
      <el-empty description="项目详情页面">
        <p>项目ID: {{ projectId }}</p>
        <el-button type="primary" @click="enterWorkspace">
          进入工作区编辑
        </el-button>
      </el-empty>
    </el-card>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'

const props = defineProps({
  projectId: {
    type: String,
    required: true
  }
})

const router = useRouter()

const goBack = () => {
  router.push({ name: 'dashboard' })
}

const enterWorkspace = () => {
  router.push({ 
    name: 'workspace', 
    params: { projectId: props.projectId } 
  })
}
</script>

<style scoped lang="scss">
.project-view {
  padding: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
